import React from 'react';
import { connect } from 'react-redux';
import { clearListSearchFilter } from '../../store/lists/actions';

import TextInput from './TextInput';
import SearchIcon from './search-icon.svg';

class SearchInput extends React.Component {
  render() {
    const searchProps = { ...this.props };
    delete searchProps.updateFieldValidity;
    delete searchProps.updateFieldFocus;
    delete searchProps.updateFieldValue;
    searchProps.prefixIcon = <SearchIcon className="FormInput__prefix-icon" />;

    return <TextInput {...searchProps} />;
  }
}

export default SearchInput;
